//cookies.run.js

"use strict";

import angular from "angular";

onRun.$inject = ["$cookies", "cookiesService", "$rootScope"];
function onRun($cookies, cookiesService, $rootScope) {
  const urlParams = new URLSearchParams(window.location.search);
  $rootScope.contact_redirect = urlParams.get("contactform")??"";
  $rootScope.token = urlParams.get("nekot")??"";
  $rootScope.redirect = urlParams.get("redir")??"";
  constructor();

  function constructor() {
    let cookies = $cookies.get("sweno.consent");
    const consent = cookies ? angular.fromJson(cookies) : undefined;
    if (consent) {
      cookiesService.setShow(false);
      if (consent.statistics) {
        cookiesService.startRegisteringEvents();
      }
    }
  }
}

export { onRun as COOKIES_RUN };
